

















































import { formatCurrency } from "@/lib/utility/currency-helper";
import { ddmmyyyhhmm } from "@/lib/utility/date-helper";
import { ICall } from "@/models/call.entity";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";

@Component({
  components: { Tooltip },
  filters: { ddmmyyyhhmm }
})
export default class RefsCall extends BaseRef<ICall> implements IRefDetail<ICall> {
  readonly RefsTypeMap = RefTypeMap;
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: ICall;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  goToDetail() {
    this.$router.push({
      name: "CallDetailView",
      params: {
        partnerId: this.item.partnerId,
        callId: this.item.id
      }
    });
  }
}
